module.exports = __webpack_public_path__ + "img/return-gray.58658456.svg";